import React from "react";
import { DollarSign, TrendingUp, TrendingDown } from "lucide-react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const RevenueMetricsCard = ({ salesData }) => {
  if (!salesData) return null;

  const formatCurrency = (value) => {
    return `₹${parseFloat(value || 0).toFixed(2)}`;
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-IN", { month: "short", day: "numeric" });
  };

  const chartData = (salesData.revenueTrend || []).map((item) => ({
    date: formatDate(item.date),
    revenue: parseFloat(item.revenue || 0),
  }));

  const isPositive = salesData.revenueGrowth >= 0;
  const growthColor = isPositive ? "text-green-600" : "text-red-600";
  const GrowthIcon = isPositive ? TrendingUp : TrendingDown;

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-green-500 rounded-md flex items-center justify-center">
            <DollarSign className="w-6 h-6 text-white" />
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">Total Revenue</h3>
            <p className="text-2xl font-semibold text-gray-900">
              {formatCurrency(salesData.totalRevenue)}
            </p>
          </div>
        </div>
        <div className={`flex items-center ${growthColor}`}>
          <GrowthIcon className="w-5 h-5 mr-1" />
          <span className="text-sm font-semibold">
            {isPositive ? "+" : ""}
            {salesData.revenueGrowth?.toFixed(1) || 0}%
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-xs text-gray-500">Total Orders</p>
          <p className="text-lg font-semibold text-gray-900">
            {salesData.totalOrders || 0}
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Avg Order Value</p>
          <p className="text-lg font-semibold text-gray-900">
            {formatCurrency(salesData.averageOrderValue)}
          </p>
        </div>
      </div>

      {chartData.length > 0 && (
        <div className="mt-4">
          <p className="text-xs text-gray-500 mb-2">7-Day Revenue Trend</p>
          <ResponsiveContainer width="100%" height={120}>
            <LineChart data={chartData}>
              <XAxis
                dataKey="date"
                tick={{ fontSize: 10 }}
                interval="preserveStartEnd"
              />
              <YAxis hide />
              <Tooltip
                formatter={(value) => formatCurrency(value)}
                contentStyle={{
                  backgroundColor: "white",
                  border: "1px solid #e5e7eb",
                  borderRadius: "6px",
                  fontSize: "12px",
                }}
              />
              <Line
                type="monotone"
                dataKey="revenue"
                stroke="#10b981"
                strokeWidth={2}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default RevenueMetricsCard;


